import React, { useState, useEffect } from 'react';
import './Hero.css';
import { stats } from '../data/schoolData';

// ── Add hero background images here ──────────────────────────
// Import your school photos and add them to this array.
// The slider will cycle through them automatically.
import imgWide from '../assets/images/schoolgate.jpeg';
import imgGate from '../assets/images/schoolground.jpeg';
import imgFront from '../assets/images/playgate.jpeg';
import principaloffice from '../assets/images/principaloffice.jpeg';
import principalonduty from '../assets/images/principalonduty.jpeg';
import jokali from '../assets/images/jokali.jpeg';
import fancydress from '../assets/images/fancydress.jpeg';
import computerlab from '../assets/images/computerlab.jpeg';
import staff from '../assets/images/staff.jpeg';
import staff1 from '../assets/images/staff2.jpeg';
import staff2 from '../assets/images/staff3.jpeg';


const slides = [
  { src: imgWide,  alt: 'School Building' },
  { src: imgGate,  alt: 'School Gate – Temple of Knowledge' },
  { src: imgFront, alt: 'School Front View' },
  { src: principaloffice, alt: 'Principal\'s Office' },
  { src: principalonduty, alt: 'Principal on Duty' },
  { src: jokali, alt: 'Jokali Event' },
  { src: fancydress, alt: 'Fancy Dress Competition' },
  { src: computerlab, alt: 'Computer Laboratory' },
  { src: staff, alt: 'Our Staff' },
  { src: staff1, alt: 'Staff Member' },
  { src: staff2, alt: 'Staff Members' }

  // Add more: { src: import('../assets/images/your-photo.jpg'), alt: 'Caption' }
];

export default function Hero() {
  const [cur, setCur] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCur(c => (c + 1) % slides.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="hero" id="home">
      {/* Slides */}
      <div className="hero-slides">
        {slides.map((s, i) => (
          <div key={i} className={`slide ${i === cur ? 'active' : ''}`}>
            <img src={s.src} alt={s.alt} />
            <div className="slide-overlay" />
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-tag">✝ Temple of Knowledge · Est. 2011</div>
          <h1>
            Shaping Futures at<br />
            <em>St. Xavier's</em><br />
            English Medium School
          </h1>
          <p>
            A minority institution committed to holistic education — nurturing minds,
            building character, and inspiring young lives in Guledgudd since 2011.
          </p>
          <div className="hero-btns">
            <a href="#about" className="btn-primary">Explore Our School</a>
            <a href="#principal" className="btn-ghost">Principal's Message</a>
          </div>
        </div>
      </div>

      {/* Dots */}
      <div className="hero-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === cur ? 'active' : ''}`}
            onClick={() => setCur(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Stats bar */}
      <div className="hero-stats">
        <div className="hero-stats-inner">
          {stats.map(s => (
            <div key={s.label} className="hstat">
              <span className="hstat-num">{s.number}</span>
              <span className="hstat-lbl">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
